/*==========================================================
HTML CLASSES SCRIPT
==========================================================*/
var topNavAdjust = false;

function checkTopNavMobile() {
    if (Modernizr.mq('(max-width: 991px)') && topNavAdjust === false) {
        topNavMobile();
    }
    if (Modernizr.mq('(min-width: 992px)') && topNavAdjust) {
        topNavReset();
    }
}

function topNavMobile() {
    if (!topNavAdjust) {

        if ($('#topNav').length) {
            $('#topNav').children().detach().appendTo('#nav').wrap('<li class="topNavMobile" />');
        }

        if ($('#headerRight .searchContainer').length) {
            $('#headerRight .searchContainer').detach().appendTo('#nav').wrap('<li class="searchMobile" />');
        }

        if ($('#ytTranslate').length) {
            $('#ytTranslate').detach().appendTo('#nav').wrap('<li />');
        }

        if ($('.topNavContainerInner .socialLinks').length) {
            $('.topNavContainerInner .socialLinks').detach().appendTo('#nav').wrap('<li />');
        }

        if ($('#translateContainer').length) {
            $('#translateContainer').detach().appendTo('#nav').wrap('<li />');
        }

        if ($('.topNavQuicklinksContainer').length) {
            $('.topNavQuicklinksContainer').detach().appendTo('#nav').wrap('<li />');
        }

        topNavAdjust = true;
    }
}

function topNavReset() {
    if (topNavAdjust) {
        topNavAdjust = false;

        if ($('.searchMobile .searchContainer').length) {
            $('.searchMobile').children().unwrap('li').detach().insertBefore('#mainNav');
        }

        if ($('#topNav').length) {
            $('.topNavMobile').children().unwrap('li').detach().prependTo('#topNav');
        }

        if ($('#ytTranslate').length) {
            if ($('#topNavContainer').find('#idLikeTo').length) {
                $('#ytTranslate').unwrap('li').detach().insertBefore('#idLikeTo');
            } else {
                $('#ytTranslate').unwrap('li').detach().appendTo('#topNavContainer');
            }
        }

        if ($('#translateContainer').length) {
            if ($('#topNavContainer').find('#idLikeTo').length) {
                $('#translateContainer').unwrap('li').detach().insertBefore('#idLikeTo');
            } else {
                $('#translateContainer').unwrap('li').detach().appendTo('.topNavContainerInner');
            }
        }

        if ($('#nav .socialLinks').length) {
            $('#nav .socialLinks').unwrap('li').detach().appendTo('.topNavContainerInner');
        }

        if ($('#nav .topNavQuicklinksContainer').length) {
            $('#nav .topNavQuicklinksContainer').unwrap('li').detach().appendTo('.topNavContainerInner');
        }
    }
}

$(window).load(function() {
    checkTopNavMobile();
});

//debounce resize instead of standard resize
$(window).debounceResize(function() {
    checkTopNavMobile();
});

$(function() {
    checkTopNavMobile();
});